<template>
  <div class="flex justify-center items-center flex-col" style="height: 100%">
    <div class="container">
      <div class="shadow"></div>
      <div class="cat">
        <div class="ear"></div>
        <div class="eye"></div>
        <div class="mouth"></div>
        <div class="nose"></div>
        <div class="tail"></div>
        <div class="body"></div>
        <div class="bubble"></div>
      </div>
    </div>
    <p class="text-center text-sm text-gray-400 italic">
      No currently ongoing event. Come back later...
    </p>
  </div>
</template>

<style scoped>
.container {
  height: 200px;
  width: 350px;
  position: relative;
}

.cat {
  background-color: #009c9c;
  height: 65px;
  width: 80px;
  border-radius: 0 80px 80px 0;
  position: absolute;
  bottom: 60px;
  right: 50px;
}

.ear {
  height: 15px;
  width: 15px;
  background-color: #014b5a;
  position: absolute;
  bottom: 64px;
  left: 8px;
  border-radius: 20px 0 0 0;
  box-shadow: 25px 0 #00626f;
}

.eye,
.eye:before {
  height: 7px;
  width: 10px;
  border: 2px solid #2c2c2c;
  position: absolute;
  border-radius: 0 0 15px 15px;
  border-top: none;
}

.eye {
  top: 18px;
  left: 15px;
}

.eye:before {
  content: "";
  left: 30px;
}

.nose {
  background-color: #ffffff;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  position: absolute;
  top: 32px;
  left: 25px;
  box-shadow: 12px 0 #ffffff;
}

.nose:before {
  content: "";
  width: 12px;
  height: 8px;
  position: absolute;
  background-color: #ffffff;
  left: 6px;
}

.nose:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  border-top: 8px solid #008e8e;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  bottom: 7px;
  left: 6px;
}

.mouth {
  background-color: #2c2c2c;
  height: 15px;
  width: 17px;
  position: absolute;
  border-radius: 0 0 5px 5px;
  top: 38px;
  left: 27px;
  animation: mouth-move 2s infinite;
  transform-origin: top;
}

@keyframes mouth-move {
  50% {
    transform: scaleY(0.7);
  }
}

.body {
  background-color: #008a8a;
  height: 90px;
  width: 140px;
  position: absolute;
  right: 65px;
  bottom: 0;
  border-radius: 60px 60px 0 0;
  animation: sleep 2s infinite;
  transform-origin: bottom right;
}

@keyframes sleep {
  50% {
    transform: scale(0.9, 1.05);
  }
}

.tail {
  background-color: #006f75;
  height: 20px;
  width: 100px;
  position: absolute;
  right: 150px;
  bottom: 0;
  border-radius: 20px 0 0 20px;
}

.body:before {
  content: "";
  position: absolute;
  background-color: #ffffff;
  height: 12px;
  width: 30px;
  border-radius: 6px;
  bottom: 0;
  left: 22px;
  box-shadow: 45px 0 #ffffff;
}

.bubble {
  height: 20px;
  width: 20px;
  background-color: rgba(200, 255, 255, 0.6);
  position: absolute;
  left: 65px;
  top: 20px;
  border-radius: 50px 50px 50px 5px;
  animation: bubble-scale 2s infinite;
}

@keyframes bubble-scale {
  50% {
    transform: scale(1.6);
  }
}

.shadow {
  height: 10px;
  width: 240px;
  background-color: rgb(193 193 193 / 50%);
  border-radius: 10px;
  position: absolute;
  bottom: 52px;
  left: 70px;
  animation: shadow 2s infinite;
}

@keyframes shadow {
  50% {
    transform: scaleX(0.6);
  }
}
</style>
